








































































































































import Vue from 'vue';
import { mapState } from 'vuex';
import {
  Component, Prop, Watch, Inject,
} from 'vue-property-decorator';
import { TransactionClassificationRuleResource, TransactionClassificationRule, TransactionClassificationIncludesRepository }
  from '@/api/transactionclassification/';
import { Alert, NoticeClass } from '@kasasa/fbase-components/lib';

@Component({ computed: mapState(['fiId']) })
export default class TransactionClassificationRuleDialog extends Vue {
    @Inject('TransactionClassificationRuleResource')
    ruleResource!:TransactionClassificationRuleResource;

    @Inject('TransactionClassificationIncludesRepository')
    includesRepository!:TransactionClassificationIncludesRepository;

    @Prop()
    rule!:TransactionClassificationRule;

    @Prop({ default: [] })
    existingRules!:Array<TransactionClassificationRule>;

    @Prop()
    smallButton!:boolean;

    @Prop()
    classificationMap:Map<string, string> | undefined;

    comboBoxValidators:Array<any> = [
      TransactionClassificationRuleDialog.lengthLessThan50,
    ];

    workingRule:TransactionClassificationRule = TransactionClassificationRuleDialog.createEmptyRule();

    fiId!:string;

    dialog:boolean = false;

    saving:boolean = false;

    enteredCode:string = '';

    enteredInclude:string = '';

    enteredExclude:string = '';

    transactionClassifications:any[] = [];

    isFormValid:boolean = false;

    savedRules:TransactionClassificationRule[] = [];

    loading = false;

    twoDecimalRule:Array<any> = [(value: any) => {
      if (value) {
        const stringVal = value.toString();
        if (stringVal) {
          const split:string[] = stringVal.split('.');
          if (split && (split.length !== 2 || split[1].length !== 2)) {
            return 'Value should be a number with two decimal places.';
          }
        }
      }

      return true;
    }];

    requiredRule:Array<any> = [(value: any) => {
      if (!value || (Array.isArray(value) && value.length === 0)) {
        return 'Required';
      }
      return true;
    }];

    initializeWorkingRule() {
      if (this.rule) {
        Object.assign(this.workingRule, this.rule);
      } else {
        this.workingRule = TransactionClassificationRuleDialog.createEmptyRule();
      }
    }

    static createEmptyRule() : TransactionClassificationRule {
      return {
        id: undefined,
        transactionClassification: 'NEEDS_MAPPING',
        transactionCodes: [],
        includePatterns: [],
        excludePatterns: [],
        predictions: [],
        keywords: [],
        requiresCheckNumber: false,
        dollarAmountFilterType: 'NONE',
        dollarAmountFilter: undefined,
        dollarAmountFilterAllowMultiples: false,
        lastQueryCount: 0,
        isSelected: false,
      };
    }

    buildClassificationsFromMap(classificationMap:Map<string, string>) {
      classificationMap.forEach((value: string, key: string) => {
        let text:string = value;
        const confidence:number|null = this.getConfidenceForClassification(key);
        if (confidence !== null) {
          const confidencePercentage = Math.trunc(confidence * 100);
          let friendlyConfidence:string = '';
          if (confidencePercentage < 1) {
            friendlyConfidence = '(<1%)';
          } else {
            friendlyConfidence = `(${confidencePercentage.toString()}%)`;
          }
          text += ` ${friendlyConfidence}`;
        }

        this.transactionClassifications.push({
          key,
          text,
          confidence,
        });
      });

      this.transactionClassifications.sort((a:any, b:any) => {
        if (a.confidence !== null && b.confidence === null) {
          return -1;
        } if (a.confidence === null && b.confidence !== null) {
          return 1;
        } if (a.confidence !== null && b.confidence !== null) {
          return b.confidence - a.confidence;
        }
        return a.text.localeCompare(b.text);
      });
    }

    getConfidenceForClassification(classification:string) : number|null {
      let confidence = null;

      if (this.workingRule.predictions) {
        for (let i = 0; i < this.workingRule.predictions.length; i++) {
          if (this.workingRule.predictions[i].transactionClassification === classification) {
            confidence = this.workingRule.predictions[i].confidence;
            break;
          }
        }
      }

      return confidence;
    }

    cancel() {
      this.initializeWorkingRule();
      this.dialog = false;
    }

    save() {
      this.saving = true;
      // Force combos to update because they might still have focus when user clicks save.
      this.updateCodes();
      this.updateIncludes();
      this.updateExcludes();
      // Wait two ticks so that combo controls can finish saving.
      this.$nextTick(() => {
        this.$nextTick(() => {
          this.ruleResource.save(this.fiId, this.workingRule).then((savedRule:TransactionClassificationRule) => {
            if (this.rule) {
              Object.assign(this.rule, savedRule);
            }

            this.savedRules = [savedRule];

            if (this.shouldMirrorTransactionClassificationRule(savedRule)) {
              this.createMirroredTransactionClassificationRule(savedRule);
            } else {
              this.$emit('success', this.savedRules);
              this.dialog = false;
              this.initializeWorkingRule();
            }
          })
            .catch((error:any) => {
              this.showError();
              this.saving = false;
            });
        });
      });
    }

    updateCodes() {
      this.$nextTick(() => {
        if (this.enteredCode) {
          this.workingRule.transactionCodes.push(...this.enteredCode.split(','));
          this.$nextTick(() => {
            this.enteredCode = '';
          });
        }
      });
    }

    updateIncludes() {
      this.$nextTick(() => {
        if (this.enteredInclude) {
          this.workingRule.includePatterns.push(...this.enteredInclude.split(','));
          this.$nextTick(() => {
            this.enteredInclude = '';
          });
        }
      });
    }

    updateExcludes() {
      this.$nextTick(() => {
        if (this.enteredExclude) {
          this.workingRule.excludePatterns.push(...this.enteredExclude.split(','));
          this.$nextTick(() => {
            this.enteredExclude = '';
          });
        }
      });
    }

    @Watch('dialog')
    onDialogToggle() {
      if (this.dialog) {
        this.saving = false;
        this.loading = true;
        this.initializeWorkingRule();

        if (this.transactionClassifications.length === 0
          && this.classificationMap !== undefined) {
          this.buildClassificationsFromMap(this.classificationMap);
        }

        this.loading = false;
      }
    }

    showError() {
      const al = new Alert('An unexpected error occurred.', NoticeClass.ERROR);
      al.setTimeout(5000);
		  this.$store.dispatch('notices/add', al);
	  }

    createMirroredTransactionClassificationRule(originalRule:TransactionClassificationRule) {
      const newRule:TransactionClassificationRule = TransactionClassificationRuleDialog.createEmptyRule();

      newRule.transactionCodes = Array.from(originalRule.transactionCodes);
      newRule.includePatterns = Array.from(originalRule.excludePatterns);
      newRule.excludePatterns = Array.from(originalRule.includePatterns);

      this.ruleResource.save(this.fiId, newRule).then((savedRule:TransactionClassificationRule) => {
        this.savedRules.push(savedRule);
        this.$emit('success', this.savedRules);
        this.dialog = false;
      })
        .catch((error:any) => {
          this.showError();
          this.saving = false;
        });
    }

    addIncludesForType(classificationType: string) {
      const noDuplicatesArray : string[] = this.getNoDuplicatesPreApprovedIncludesForType(this.workingRule.transactionClassification);
      const patterns = this.workingRule.includePatterns ? this.workingRule.includePatterns : [];
      const allArray: string[] = patterns.concat(noDuplicatesArray);
      this.workingRule.includePatterns = allArray;
    }

    shouldDisableIncludesButton(classificationType: string) : boolean {
      const noDuplicatesArray : string[] = this.getNoDuplicatesPreApprovedIncludesForType(this.workingRule.transactionClassification);
      return noDuplicatesArray.length === 0;
    }

    getNoDuplicatesPreApprovedIncludesForType(classificationType: string) : string[] {
      const classificationTypes : string[] = this.includesRepository.getForTransactionType(classificationType);
      const patterns = this.workingRule.includePatterns ? this.workingRule.includePatterns : [];
      const noDuplicatesArray : string[] = classificationTypes.filter((c) => {
        for (let patternIndex = 0; patternIndex < patterns.length; patternIndex++) {
          if (c.toUpperCase() === patterns[patternIndex].toUpperCase()) {
            return false;
          }
        }
        return true;
      });
      return noDuplicatesArray;
    }

    shouldMirrorTransactionClassificationRule(rule:TransactionClassificationRule) : boolean {
      if (rule.includePatterns.length === 0 && rule.excludePatterns.length === 0) {
        return false;
      }

      if (this.includesRepository.isFillableType(rule.transactionClassification)) {
        return false;
      }

      for (let i = 0; i < this.existingRules.length; i++) {
        const existingRule = this.existingRules[i];
        if (rule.id !== existingRule.id) {
          if (TransactionClassificationRuleDialog
            .hasIntersectingElements(rule.transactionCodes, existingRule.transactionCodes)) {
            if (TransactionClassificationRuleDialog
              .hasIntersectingElements(rule.includePatterns, existingRule.excludePatterns)) {
              return false;
            }
            if (TransactionClassificationRuleDialog
              .hasIntersectingElements(rule.excludePatterns, existingRule.includePatterns)) {
              return false;
            }
          }
        }
      }
      return true;
    }

    static hasIntersectingElements(firstArray:Array<string>, secondArray:Array<string>) : boolean {
      for (let i = 0; i < firstArray.length; i++) {
        const element = firstArray[i];
        if (secondArray.includes(element)) {
          return true;
        }
      }
      return false;
    }

    static lengthLessThan50(values: any) {
      for (let i = 0; i < values.length; i++) {
        if (values[i].length > 50) {
          return 'Length can be no greater then 50 characters long';
        }
      }
      return true;
    }
}
